export enum INPUT_SIZE {
  small = "small",
  medium = "medium",
}

export enum INPUT_KIND {
  primary = "primary",
  secondary = "secondary",
}
